import { axiosSwagger } from "@/axios";

export const state = {
    pinFolder: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // PIN FOLDER
    pinFolderLoading: (state, loading) => {
        state.pinFolder.loading = loading;
    },
    setPinFolderData: (state, data) => {
        state.pinFolder.data = modifyData( data );
    },
    setPinFolderTotal: (state, total) => {
        state.pinFolder.total = total;
    },
    removePinFolder: (state, id) => {
        state.pinFolder.data = state.pinFolder.data.filter(
            (el) => el.id !== id
        );
    },
}


export const actions = {
    // READ PIN FOLDER
    async readPinFolder({ commit }) {
        commit("pinFolderLoading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
        
        return await axiosSwagger
        .get(`/api/FileFolder/Pinned/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            commit("setPinFolderData", response.data);
            commit("setPinFolderTotal", response.data.length);
            commit("pinFolderLoading", false);

            return response;
        })
        .catch(() => {
            commit("pinFolderLoading", false);
        });
    },
    // REMOVE PIN FOLDER
    async removePinFolder({ commit }, id) {
        return await axiosSwagger
        .put(`/api/FileFolder/UnPin/${id}`)
        .then((response) => {
            commit("removePinFolder", id);

            return response;
        });
    },
}



// modify data for totalFileSize
const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
      arrayData.forEach(e => {
        e.totalFileSize = (e.fileManagers?.length ?? false) ? sum(e.fileManagers, 'totalFileSize') : 0;
      });
  
      return arrayData;
    }
  
    return [];
};
  
const sum = (array, key) => {
return array.reduce((accumulator, object) => {
    return accumulator + object[key];
}, 0);
}